import { Auth } from 'aws-amplify';
import { Login } from '../../Types';
import { enforceOnboarding, forwardUrlParams, pathname } from '..';
import mixpanel from '@8fig/mixpanel';

export async function login({
  email,
  password,
  signIn,
  history,
  setUser,
  setHasCompletedOnboarding,
  setActiveStep,
  runSignIn = true,
}: Login) {
  const user = await Auth.signIn(email, password);
  if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
    setUser(user);
    history.push({
      pathname: pathname.preLogin.changePw.url,
      search: forwardUrlParams(),
    });
  } else {
    mixpanel.identify(email);
    mixpanel.people.set({ $last_login: new Date() });
    if (runSignIn) {
      signIn(email);
      await enforceOnboarding(
        setHasCompletedOnboarding,
        setActiveStep,
        history,
      );
    }
  }
}
